// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';
import { Input } from '@angular/core';
const wiz = new Wiz({ appId: 'component.icon', namespace: 'icon' });
@AngularComponent({
  selector: 'wiz-icon',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class ComponentIconComponent {
 @Input() name='cube';
 public paths:Record<string,string>={
 'chevron-left':'m15 5-7 7 7 7','chevrons-left':'m11 5-7 7 7 7 m9-14-7 7 7 7','chevrons-right':'m4 5 7 7-7 7 m9-14 7 7-7 7',
 back:'M20 12H4 m6-6-6 6 6 6',download:'M4 15v6h16v-6 M12 3v13 m-5-5 5 5 5-5',folder:'M3 6h7l2 3h9v12H3z',save:'M4 3h13l4 4v14H3V3z M7 3v6h9V3 M7 21v-8h10v8',
 grid:'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
 cube:'m12 3 9 5v8l-9 5-9-5V8z M3 8l9 5 9-5 M12 13v8 M7.5 5.5l9 5',
 server:'M4 3h16v7H4z M4 14h16v7H4z M7 6.5h.01 M7 17.5h.01 M11 6.5h6 M11 17.5h6',
 globe:'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M3 12h18 M12 3c5 5 5 13 0 18-5-5-5-13 0-18',
 layers:'m12 3 10 5-10 5L2 8z M2 12l10 5 10-5 M2 16l10 5 10-5',
 layout:'M3 3h18v18H3z M3 9h18 M9 9v12',
 terminal:'M3 4h18v16H3z m4 4 4 4-4 4 M13 16h4',
 calendar:'M4 5h16v16H4z M8 3v4 M16 3v4 M4 11h16 M8 15h2 M14 15h2',
 chart:'M3 3v18h18 M7 16v-5 M12 16V7 M17 16v-8',
 history:'M3 11a9 9 0 1 1 2.5 7 M3 4v7h7 M12 7v5l3 2',
 settings:'m9 3-.5 3-2 1-3-.8L2 9l2.5 2v2L2 15l1.5 2.8 3-.8 2 1L9 21h6l.5-3 2-1 3 .8L22 15l-2.5-2v-2L22 9l-1.5-2.8-3 .8-2-1L15 3z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
 plus:'M12 5v14 M5 12h14',chevron:'m9 5 7 7-7 7',down:'m6 9 6 6 6-6',arrow:'M4 12h16 m-6-6 6 6-6 6',
 search:'M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0 m-2 5 7 7',
 refresh:'M3 11a9 9 0 0 1 15.36-6.36L21 7 M21 3v4h-4 M21 13a9 9 0 0 1-15.36 6.36L3 17 M3 21v-4h4',
 check:'m5 12 4 4L19 6',close:'m6 6 12 12 M6 18 18 6',
 spark:'m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z',
 shield:'m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6z m-4 9 3 3 5-6',
 lock:'M5 10h14v11H5z M8 10V7a4 4 0 0 1 8 0v3 M12 14v3',
 logout:'M9 4H4v16h5 M9 12h12 m-4-4 4 4-4 4',
 menu:'M4 6h16 M4 12h16 M4 18h16',
 bell:'M6 9a6 6 0 0 1 12 0c0 8 3 8 3 8H3s3 0 3-8 M10 21h4',
 upload:'M4 15v6h16v-6 M12 16V3 m-5 5 5-5 5 5',
 file:'M5 3h9l5 5v13H5z M14 3v6h5 M9 13h6 M9 17h6',
 clock:'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M12 7v5l3 2',
 activity:'M2 12h5l3-8 4 16 3-8h5',
 database:'M20 6c0 4-16 4-16 0s16-4 16 0 M4 6v12c0 4 16 4 16 0V6 M4 12c0 4 16 4 16 0',
 external:'M14 3h7v7 M21 3 11 13 M10 5H3v16h16v-7',
 trash:'M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7',
 copy:'M9 9h12v12H9z M15 9V3H3v12h6',edit:'m4 16-1 5 5-1L21 7l-5-5z M13 5l5 5',
 'eye-off':'M3 3l18 18 M2 12s4-7 10-7c2 0 4 1 5.5 2.5 M22 12s-4 7-10 7c-4 0-7-3-9-6 M10 10a3 3 0 0 0 4 4',
 eye:'M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7 M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
 inbox:'M5 4h14l3 11v5H2v-5z M2 15h6l2 3h4l2-3h6',
 play:'m7 4 14 8-14 8z',stop:'M5 5h14v14H5z',help:'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M9 9a3 3 0 0 1 6 0c0 2-3 2-3 4 M12 17h.01'
 };
}

export default ComponentIconComponent;
